import { Routes } from '@angular/router';
import { BbitAuthGuard, bbitWebsiteAuthRoutes } from '@bbitgmbh/website.sdk';
import { AccountComponent } from './account/account.component';
import { DocumentComponent } from './account/document/document.component';
import { DocumentsComponent } from './account/documents/documents.component';
import { PlaceBookingsComponent } from './account/place-bookings/place-bookings.component';
import { ProfileComponent } from './account/profile/profile.component';
import { BookingComponent } from './booking/booking/booking.component';
import { BookingSelectionComponent } from './booking/booking-selection/booking-selection.component';
import { CampingMapComponent } from './camping/camping-map/camping-map.component';
import { CampingSelectionComponent } from './camping/camping-selection/camping-selection.component';
import { ImprintComponent } from './imprint/imprint.component';
import { LegalComponent } from './legal/legal.component';
import { PrivacyComponent } from './privacy/privacy.component';

export const appRoutes: Routes = [
  ...bbitWebsiteAuthRoutes,
  {
    path: 'account',
    component: AccountComponent,
    canActivate: [BbitAuthGuard],
    children: [
      { path: 'profile', component: ProfileComponent },
      { path: 'place-bookings', component: PlaceBookingsComponent },
      { path: 'documents/:_bucket', component: DocumentsComponent },
      { path: 'document/:_bucket/:_id', component: DocumentComponent },
      { path: '', redirectTo: 'profile', pathMatch: 'full' },
    ],
  },
  { path: 'imprint', component: ImprintComponent },
  { path: 'legal', component: LegalComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'camping', component: CampingSelectionComponent },
  { path: 'camping/:id', component: CampingMapComponent },
  { path: 'places', component: BookingSelectionComponent },
  { path: 'places/book', component: BookingComponent },
  { path: '', component: BookingSelectionComponent },
  { path: '**', redirectTo: '', pathMatch: 'full' },
  // { path: '**', component: TempUpdatingComponent },
];
